import ReactJson from 'react-json-view'
import { useState } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap'
import { useSimulationQuestionScoreMutation } from '../../store/api/simulation/simulation.api'
import { responseError } from '../../validation/validationRequaired'
import {
  ISimulationQuestionScoreResponse,
  ISimulationSendToBeck
} from '../../store/api/simulation/model'
import Loading from '../Loading/Loading'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const Simulation = (): JSX.Element => {
  const { t: tSideBar } = useTranslation('sideBar')
  const { t: tGeneral } = useTranslation('general')
  const [simulationQuestionScore] = useSimulationQuestionScoreMutation()
  const [sendToBeck, setSendToBeck] = useState<ISimulationSendToBeck | null>(null)
  const [simulationScore, setSimulationScore] = useState<ISimulationQuestionScoreResponse>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const changeField = (field: string, value: string): void => {
    setSendToBeck(prev => ({ ...prev, [field]: value }))
  }

  const handleSimulationQuestionScore = async (): Promise<void> => {
    setIsLoading(true)
    const res = await simulationQuestionScore(sendToBeck)

    if ('error' in res) {
      responseError(res)
    } else {
      setSimulationScore(res.data)
      if (res?.data?.message) {
        toast.warning(res.data.message)
      }
    }
    setIsLoading(false)
  }

  return (
    <div className='mt-8'>
      {isLoading && <Loading />}
      <Card>
        <CardHeader>
          <div>
            <h2>{tSideBar('Simulation')}</h2>
          </div>
        </CardHeader>
        <Row>
          <CardBody>
            <Col>
              <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                {tGeneral('question')}
              </label>
              <input
                defaultValue={sendToBeck?.question}
                name='question'
                className='form-control'
                placeholder={tGeneral('question')}
                onChange={({ target }) => changeField(target.name, target.value)}
              />
            </Col>
            <Col>
              <label className='text-dark  mt-5' htmlFor='exampleInputname'>
                {tGeneral('answer')}
              </label>
              <input
                defaultValue={sendToBeck?.answer}
                name='answer'
                className='form-control'
                placeholder={tGeneral('answer')}
                onChange={({ target }) => changeField(target.name, target.value)}
              />
            </Col>
            {simulationScore?.result ? (
              <Col className='mt-5'>
                <ReactJson
                  src={JSON.parse(simulationScore?.result)}
                  theme='monokai'
                  collapsed={false}
                  enableClipboard={false}
                />
              </Col>
            ) : null}
          </CardBody>
          <Card.Footer className='text-end'>
            <button onClick={handleSimulationQuestionScore} className='btn btn-success mt-1 me-2'>
              Save
            </button>
          </Card.Footer>
        </Row>
      </Card>
    </div>
  )
}

export default Simulation
